<h1 mat-dialog-title>{{ 'SITE_INVESTIGATION_WITH_TOKEN/dialog/store/title' | translate }}</h1>
<div mat-dialog-content>
  <p>{{ 'SITE_INVESTIGATION_WITH_TOKEN/dialog/store/1' | translate }}</p>
  <p>{{ 'SITE_INVESTIGATION_WITH_TOKEN/dialog/store/2' | translate }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button class="primary-button" (click)="onClickOk()" cdkFocusInitial>{{ 'SITE_INVESTIGATION_WITH_TOKEN/dialog/store/btn/ok' | translate }}</button>
</div>
